import { useCallback } from 'react';
import type { DashboardConfig, DashboardSlot } from '../types/dashboard.types';
import { renderDashboardSlot } from '../utils/renderDashboardSlot';

export const useDashboard = (config: DashboardConfig) => {
	const { userSummary, stats, promotion, slots } = config;

	const renderSlot = useCallback((slot: DashboardSlot) => {
		return renderDashboardSlot(slot);
	}, []);

	return {
		userSummary,
		stats,
		promotion,
		slots,
		renderSlot,
	};
};
